export * from './confirm-forgot-password';

export * from './forgot-password.component';
